import { formatHtml } from "@trumpf/ux.common-storybook";
import { html } from "lit";

const Template = () =>
    html`<ux-iws-cookie-required>
        <div slot="headline">Cookie required</div>
        <div>
            This website uses cookies to ensure you get the best experience on
            our website. By using our website you agree to our
            <a href="#">cookie policy</a>.
        </div>
    </ux-iws-cookie-required>`;

export default {
    title: "Components/Cookie Required",
    render: Template.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-comparison-table",
};

export const Default = {};
